<template>
  <el-dialog
      :title="$t('socialPosts.create.publishNow.title')"
      :visible.sync="modalConfirmPublishNow"
      v-loading="loadingStatus"
      width="45%"
      @close="closeModal">
        <span class="text-left">
          {{ $t('socialPosts.create.publishNow.text') }}
        </span>
    <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="confirm()" :disabled="loading" :loading="loading">{{ $t('socialPosts.create.publishNow.confirm') }}</el-button>
          <el-button @click="closeModal()" :disabled="loading">{{ $t('socialPosts.create.publishNow.cancel') }}</el-button>
        </span>
  </el-dialog>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'DialogPublishNow',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial', [
      'modalConfirmPublishNow',
      'loadingStatus']),
    ...mapGetters('socialPostsCreationPostEditorial',
      ['getModalConfirmPublishNow'])
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setModalConfirmPublishNow']),
    ...mapActions('socialPostsCreationPostEditorial',
      ['handlePublish', 'validatePost']),
    async confirm () {
      // Vérifier s'il y a un conflit de médias avant de publier maintenant
      if (this.$store.getters['socialPostsCreationPostEditorial/hasMediaConflict']) {
        // Stocker que l'action en cours est la publication immédiate
        this.$store.commit('socialPostsCreationPostEditorial/setPendingActionType', 'publishNow')
        this.$store.commit('socialPostsCreationPostEditorial/setModalMediaImageAndVideo', true)
        return
      }
      
      this.loading = true
      
      // Forcer la mise à jour de Vue
      this.$forceUpdate()
      await this.$nextTick()
      
      try {
        await this.handlePublish()
      } catch (error) {
        console.error('Erreur lors de la publication immédiate:', error)
      } finally {
        this.loading = false
        this.$forceUpdate()
      }
    },
    closeModal () {
      this.loading = false
      this.setModalConfirmPublishNow(false)
    }
  },
  watch: {
    modalConfirmPublishNow (newVal) {
      // Désactiver le loader quand la modale se ferme
      if (!newVal) {
        this.loading = false
      }
    }
  }
}
</script>

<style>

</style>
